export const environment = {
    production: false,
    backendUrl: '/back',
    backendUri: '',
    activate_log: '',
    log_level: '',
    mail_test: 'test@campus.fr',
    log_classes: [],
    casServeurUrl: 'https://recette-auth.campusfrance.org/keycloak/realms/campus-france',
    casClientId: 'eclectus-dev',
    casScopes: 'openid offline_access'
};
